import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Grid, Toolbar } from "@mui/material";
import Sidebar from "./Sidebar";
import Main from "./Main"; // Import the Main component

function TagsDetails() {
  const [questions, setQuestions] = useState([]);
  const { tagName } = useParams();

  useEffect(() => {
    async function fetchQuestions() {
      try {
        const response = await axios.get("/api/question", {
          baseURL: process.env.REACT_APP_FORUM_API,
        });
        const allQuestions = response.data || [];
        const filteredQuestions = allQuestions.filter((q) =>
          q.tagDetails.some((tag) => tag.name === tagName)
        );
        setQuestions(filteredQuestions);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    }
    fetchQuestions();
  }, [tagName]);

  return (
    <Grid container>
      <Grid item container xs={12}>
        <Grid
          item
          xs={2}
          sx={{
            position: "sticky",
            top: 0,
            alignSelf: "flex-start",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <Toolbar style={{ minHeight: "30px" }} sx={{ height: "0.5rem" }} />
          <Sidebar />
        </Grid>

        <Grid item xs={10}>
          <h4
            style={{
              marginTop: "15px",
              marginLeft: "15px",
            }}
          >
            [{tagName}]
          </h4>
          <Main
            questions={questions}
            isTagDetailsPage={true}
            style={{
              marginTop: "20px",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default TagsDetails;
